var _defs, _text, _text2, _text3, _text4, _path, _path2, _rect, _rect2, _path3, _path4, _polygon, _polygon2, _text5, _text6, _text7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsrlogofinal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1202 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:38.08px;font-family:KelveticaNobis, Kelvetica Nobis;}.cls-1,.cls-10{fill:#1f2f75;}.cls-2{letter-spacing:-0.01em;}.cls-3{letter-spacing:-0.01em;}.cls-4{letter-spacing:0em;}.cls-5{letter-spacing:0em;}.cls-6{font-size:57.97px;}.cls-6,.cls-8{fill:#f15b22;}.cls-11,.cls-6{font-family:Karmella-Regular, Karmella;}.cls-11,.cls-7{fill:#636464;}.cls-9{fill:#288b3e;}.cls-11{font-size:38.94px;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(375.43 674.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.97,
    y: 0
  }, "eading "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 155.54,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 166.1,
    y: 0
  }, "n Right Di"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 339.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 353.51,
    y: 0
  }, "ection"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(638.55 496.3)"
  }, "M")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(648.23 560.96)"
  }, "S")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(644.49 625.62)"
  }, "R")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.3,500.56v-27c-14.51.62-21.76,7.73-21.76,16.43v10.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.32,500.56h21.77V490c0-8.7-9.68-15.81-21.77-16.43Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 490.32,
    y: 504.35,
    width: 21.76,
    height: 20.71
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 463.54,
    y: 504.35,
    width: 21.76,
    height: 20.71
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M393.92,610.13V525.72l-15.24,9.84v90.25H603.53V522.25l-15.24,13.31v74.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M588.29,412.85v85l15.24-10.42V397.18H378.68v103l15.24-12.74V412.85Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "491 607.36 421.46 526.67 438.71 511.38 493.55 574.92 611.58 474.12 626.46 491.64 491 607.36"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "492.07 415.06 561.61 495.74 544.36 511.03 489.52 447.49 371.49 548.3 356.61 530.78 492.07 415.06"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(695.79 496.28)"
  }, "ana")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(695.79 561.72)"
  }, "ampada")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(695.79 626.07)"
  }, "ealtors")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsrlogofinal);
export default __webpack_public_path__ + "static/media/msrlogofinal.f67c6a69bee10c90befbc3e465d139b6.svg";
export { ForwardRef as ReactComponent };